<template>
    <div  v-if="!node.hidden" role="treeitem" tabindex="-1" aria-disabled="false" draggable="false" class="el-tree-node is-expanded is-current is-focusable is-checked" aria-checked="true" aria-expanded="true">
        <!--节点信息-->
        <div @click="toggleNode" class="el-tree-node__content" :style="{'padding-left': '' + (level * 20) + 'px', height: '' + nodeHeight + 'px'}">

            <!--展开&收起图标-->
            <span class="el-tree-node__expand-icon el-icon-caret-right" :class="{'expanded':node.isExpanded, 'is-leaf':!node.isExpandable}"/>

            <!--选中框-->
            <label v-if="enableSelected" class="el-checkbox is-checked" aria-controls="undefined">
            <span class="el-checkbox__input" @change.prevent="toggleCheck" :class="{'is-checked': 1 === isSelected, 'is-indeterminate': 2 === isSelected}">
                <span class="el-checkbox__inner"/>
                <input type="checkbox" aria-hidden="false" class="el-checkbox__original" value="" tabindex="-1"/>
            </span>
            </label>

            <!--节点Label展现-->
            <span :title="getLabel" class="el-tree-node__label" :class="{'is-selected':isLastClickNode}">{{getLabel}}  {{getCountLabel}}</span>
        </div>

        <!--子节点信息-->
        <div v-if="node.isExpandable && node.isExpanded" role="group" class="el-tree-node__children" data-old-padding-top="" data-old-padding-bottom="" data-old-overflow="" style="" aria-expanded="true">
            <div v-if="fillerInfo.fillerBeforeCount > 0" :style="{height: '' + (fillerInfo.fillerBeforeCount * nodeHeight) + 'px'}"/>
            <TreeNode v-for="(child, index) in fillerInfo.visibleChildren" :key="index" :node="child" :root="root"
                      :level="level + 1" :selector="selector" :enableSelected="enableSelected" :clickCallback="clickCallback"
                      :treeInfo="treeInfo"/>
            <div v-if="fillerInfo.fillerAfterCount > 0" :style="{height: '' + (fillerInfo.fillerAfterCount * nodeHeight) + 'px'}"/>
        </div>
    </div>
</template>


<script>
    import TreeUtil from "./TreeUtil";

    export default {
        name: "TreeNode",
        props: {
            root: Array,                  //根节点
            node: Object,                 //节点数据
            level: Number,                //层级； 用于缩进
            selector: Object,             //选择相关计算器
            treeInfo: Object,             //树本身数据
            clickCallback: Function,      //点击节点事件
            enableSelected:Boolean,
        },
        data: function () {
            return {
                nodeHeight: TreeUtil.Constant.NODE_HEIGHT,
            };
        },
        computed: {
            //获取滚动窗口填充和应显示节点信息
            fillerInfo() {
                return TreeUtil.getScrollFillerInfo(this.node, this.treeInfo.scrollRange);
            },

            //节点展示信息
            getLabel() {
                let labelName = this.node.email ? this.node.name + " <" + this.node.email + ">" : this.node.name;
                labelName = labelName ? labelName : '空'
                return labelName
                // return this.node.email ? this.node.name + " <" + this.node.email + ">" : this.node.name;
            },

            //节点选择计数&总数展示信息
            getCountLabel() {
                return this.node.isFolder && this.node.id !== 'orgRoot' && this.node.id !== 'persRoot' ?
                    '(' + (this.enableSelected?  this.node.selectedCount + '/' :'') + this.node.totalCount + ')' : '';
            },

            //获取选择状态（TreeSelectType）
            isSelected() {
                return TreeUtil.getSelected(this.node);
            },

            //是否中当前点击的节点
            isLastClickNode() {
                return this.$store.getters.treeViewLastClickNodeId === this.node.id;
            }
        },
        methods: {
            //点击选择 checkbox
            toggleNode() {
                if (this.node.isExpandable) {
                    this.node.isExpanded = !this.node.isExpanded;
                    TreeUtil.computeSerialNumber(this.root); //TODO 优化效率 不用全树
                } else {
                    this.toggleCheck();
                }
                if (this.clickCallback) {
                    this.clickCallback(this.node);
                }
            },

            //点击展开&收起
            toggleCheck() {
                if (TreeUtil.TreeSelectType.ALL === TreeUtil.getSelected(this.node)) {
                    TreeUtil.unSelectAll(this.node, this.selector.selectIds);
                } else {
                    TreeUtil.selectAll(this.node, this.selector.selectIds);
                }
                TreeUtil.computeSelectedCount(this.root); //TODO 优化效率 不用全树
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/core/tree/TreeNode.vue